import { TableFade } from './table-fade';

export default TableFade;
